<template>
	<div class="machine-group">
		<div class="el-search vue-top-padding radius">
			<div class="el-left">
				<el-button
					@click="handlerInsert"
					v-hasPerm="['product:library:insert']"
					type="primary"
					size="small"
					icon="el-icon-plus"
					style="margin: 0"
					>{{ $t("product.ProductLibrary.994606-0") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height">
					<el-form-item prop="name" style="margin-bottom: 0">
						<el-input
							v-model="search.name"
							:placeholder="$t('product.ProductLibrary.994606-1')"></el-input>
					</el-form-item>
					<el-form-item style="margin: 0">
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button @click="resetSearch()" icon="el-icon-refresh">{{
							$t("common.reset")
						}}</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="vue-padding">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="tableList"
				style="width: 100%"
				max-height="638"
				:border="true">
				<el-table-column
					prop="name"
					:show-overflow-tooltip="true"
					:label="$t('product.ProductLibrary.994606-1')"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="image"
					:label="$t('product.ProductLibrary.994606-2')"
					:align="'center'">
					<template slot-scope="scope">
						<el-image
							@click="handlerLookItem(scope.row)"
							:preview-src-list="srcList"
							:src="scope.row.url"
							fit="contain"
							style="width: 50px; height: 50px; cursor: pointer"></el-image>
					</template>
				</el-table-column>
				<el-table-column
					:label="$t('product.ProductLibrary.994606-3')"
					:align="'center'"
					fixed="right">
					<template slot-scope="scope">
						<el-button
							style="margin: 3px"
							size="mini"
							type="success"
							@click="getProductType(scope.row)"
							>{{ $t("product.ProductLibrary.994606-4") }}</el-button
						>
						<el-button
							v-if="scope.row.uId == uId || pId == 0"
							style="margin: 3px"
							size="mini"
							v-hasPerm="['product:library:update']"
							type="warning"
							@click="handlerEdit(scope.row)"
							>{{ $t("common.edit") }}</el-button
						>
						<el-button
							v-if="scope.row.uId == uId || pId == 0"
							style="margin: 3px"
							size="mini"
							v-hasPerm="['product:library:delete']"
							type="danger"
							@click="delProductType(scope.row)"
							>{{ $t("product.ProductLibrary.994606-5") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				v-if="tableList.length > 0"
				background
				layout="prev, pager, next"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@current-change="currentChange"></el-pagination>
		</div>
		<add-product
			:dialogProduct="dialogProduct"
			v-on:cancel="cancel"
			:productTags="productTags"
			:product="product"
			:fromMaterial="fromMaterial"
			:fromLibrary="true">
		</add-product>
	</div>
</template>

<script>
import addProduct from "_c/product/AddProduct";

export default {
	name: "ProductLibrary",
	components: {
		addProduct,
	},
	data() {
		return {
			search: {},
			loading: false,
			tableList: [],
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			dialogProduct: false,
			product: {
				costPrice: "",
				goodsTags: [],
				name: "",
				typeId: "",
				url: "",
				content: "",
				introduction: "",
				no: "",
				notes: "",
				id: "",
			},
			// 弹窗相关
			productTags: [],
			srcList: [],
			showUploadImg: false,
			pId: -1,
			uId: -1,
			fromMaterial: "0",
		};
	},

	async mounted() {
		this.pId = localStorage.getItem("pId") || -1;
		this.uId = localStorage.getItem("uId") || -1;
		// await this.handlerOpenDoorSh();
		// await this.handlerGetSpecTType();
		this.listProductTag();
		this.currentChange();
	},
	methods: {
		handlerUploadImg(row) {
			this.productItem = row;
			this.isReUpload = false;
			this.showUploadImg = true;
		},
		handlerReUploadImg(row) {
			this.productItem = row;
			this.isReUpload = true;
			this.showUploadImg = true;
		},
		closeUploadImg() {
			this.showUploadImg = false;
		},
		refreshUploadImg() {
			this.showUploadImg = false;
			this.currentChange();
		},
		listProductTag() {
			this.$api
				.request(this.$url.ProductTag.list, this.$method.get)
				.then(res => {
					if (res.code === 0) {
						this.productTags = res.data;
					}
				});
		},
		cancel(dialog, status) {
			this.dialogProduct = dialog;
			if (status) {
				this.currentChange();
			}
		},
		closeLookImg() {
			this.showLookImg = false;
		},
		handlerLookImgs(row) {
			this.productItem = row;
			this.showLookImg = true;
		},
		handlerIsStatus(row, status) {
			if (row.productSpecType !== "open_door") return false;
			if (row.openDoorSkuDTO === null) return false;
			if (row.openDoorSkuDTO.skuResult === status) return true;
			return false;
		},
		handlerROpenDoorStatus(row) {
			if (row.productSpecType !== "open_door") return "";
			if (row.openDoorSkuDTO === null) return "";
			if (row.openDoorSkuDTO.skuResult === null) return "";
			return this.openDoorResList.find(
				item => item.dictValue == row.openDoorSkuDTO.skuResult
			).dictLabel;
		},
		handlerRType(type) {
			if (!type) return "";

			return this.specifyTypeList.find(item => item.dictValue == type)
				.dictLabel;
		},
		//开门柜规格类型
		async handlerOpenDoorSh() {
			try {
				const res = await this.$api.dict("gp_opendoor_skuresult");
				if (res.code === 0) {
					this.openDoorResList = res.data;
				} else {
					console.error("Failed to fetch data:", res.message);
				}
			} catch (error) {
				console.error("Promise Error:", error);
			}
		},
		// //规格类型
		// async handlerGetSpecTType() {
		// 	try {
		// 		const res = await this.$api.dict("product_specify");
		// 		if (res.code === 0) {
		// 			this.specifyTypeList = res.data;
		// 		} else {
		// 			console.error("Failed to fetch data:", res.message);
		// 		}
		// 	} catch (error) {
		// 		console.error("Promise Error:", error);
		// 	}
		// },
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.ProductLibrary.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.tableList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},

		// 搜索
		onSubmit() {
			this.currentChange();
		},
		// 重置搜索
		resetSearch() {
			this.searchTime = null;
			Object.keys(this.search).map(key => (this.search[key] = null));
			this.currentChange();
		},
		// 添加/编辑
		handlerInsert() {
			// 初始化insert数据
			Object.keys(this.product).forEach(key => (this.product[key] = ""));
			this.product.goodsTags = [];
			this.fromMaterial = "1";
			this.dialogProduct = true;
		},
		// 编辑素材库商品（保留 id 走更新）
		handlerEdit(row) {
			Object.keys(this.product).forEach(key => {
				this.product[key] = row[key] !== undefined ? row[key] : "";
			});
			this.product.id = row.id;
			if (!this.product.goodsTags) this.product.goodsTags = [];
			this.fromMaterial = "1";
			this.dialogProduct = true;
		},
		handleClose() {
			this.dialogVisible = false;
		},
		delProductType(row) {
			this.$confirm(this.$t("product.delete"), this.$t("common.warning"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api
					.request(this.$url.ProductLibrary.delete, this.$method.delete, {
						id: row.id,
					})
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.currentChange();
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch(err => {
						this.$message.error(err.msg);
					});
			});
		},
		getProductType(row) {
			this.fromMaterial = "0";
			Object.keys(this.product).forEach(key => {
				this.product[key] = row[key];
			});
			delete this.product.id;
			this.dialogProduct = true;
		},
		handlerLookItem(row) {
			this.srcList = [row.url];
		},
	},
};
</script>

<style scoped>
.el-dialog__header {
	padding: 20px;
}
.el-dialog__body {
	padding: 0 20px;
	height: auto !important;
}
.el-dialog__footer {
	padding: 20px;
}
</style>
